import {
  type FeatureResponse,
  type GeocodeEarthResponse,
} from '@/libs/geocode-earth/geocode-earth-types';
import placeNameToUrl from "@/features/place/utils/place-name-to-url";

export default function geocodeFilterSearchResults(features: GeocodeEarthResponse['features'], geocoding: GeocodeEarthResponse['geocoding']): FeatureResponse | undefined {
  const matchByName = features.filter((feature) => placeNameToUrl(feature.properties.label) === placeNameToUrl(geocoding.query.text));

  if (matchByName.length > 0) {
    return matchByName[0];
  }

  const exactMatch: FeatureResponse[] = [];
  const confidence: FeatureResponse[] = [];

  if (features.length === 0 || features.length === 1) {
    return features[0];
  }

  // let exatchMatchDebug = '';
  // let exatchMatchNumberDebug = 0;
  const exatchMatchIds: string[] = [];
  // let confidenceDebug = '';
  // let confidenceNumberDebug = 0;
  const confidenceIds: string[] = [];

  const sortedFeatures = features.toSorted((a, b) => {
    // TODO: remove when will be separated types for feature search and autocomplete
    return b.properties.confidence && a.properties.confidence ? b.properties.confidence - a.properties.confidence : 0;
  });

  // NOTE: Don't use compare by name because it will return for example on search "new-york" city "New York in Santa Rosa County, Florida, United States"
  sortedFeatures.forEach((feature) => {
    if (feature.properties.match_type === 'exact') {
      // exatchMatchNumberDebug += 1;
      // exatchMatchDebug = `[label: ${feature.properties.label}] ${feature.properties.match_type} = exact`;
      exatchMatchIds.push(feature.properties.id);
      exactMatch.push(feature);
    }

    if (feature.properties.confidence === 1) {
      // confidenceNumberDebug += 1;
      // confidenceDebug = `[label: ${feature.properties.label}] ${feature.properties.confidence} = 1`;
      confidenceIds.push(feature.properties.id);
      confidence.push(feature);
    }
  });

  if (exactMatch.length > 0) {
    // console.log(`====> matchByName, count - ${exatchMatchNumberDebug}:`, exatchMatchDebug);
    // console.log(`====> exactMatch[0] - ${exactMatch[0].properties.label}:`);
    return exactMatch[0];
  }

  if (confidence.length > 0) {
    // console.log(`====> matchByName, count - ${confidenceNumberDebug}:`, confidenceDebug);
    // console.log(`====> confidence[0] - ${confidence[0].properties.label}:`);
    return confidence[0];
  }

  if (geocoding.query.parsed_text.region) {
    const featuresByRegion = sortedFeatures.filter((feature) => {
      if (feature.properties.region_a) {
        return feature.properties.region_a.toLowerCase() === geocoding.query.parsed_text.region?.toLowerCase()
          || feature.properties.region.toLowerCase() === geocoding.query.parsed_text.region?.toLowerCase();
      }
    });

    if (featuresByRegion.length === 0) {
      return sortedFeatures[0];
    }

    if (featuresByRegion.length === 1) {
      return featuresByRegion[0];
    }

    if (geocoding.query.parsed_text.locality) {
      const featuresByCity = featuresByRegion.filter((feature) => {
        if (feature.properties.locality) {
          return feature.properties.locality.toLowerCase() === geocoding.query.parsed_text.locality?.toLowerCase();
        }
      });

      if (featuresByCity.length === 0) {
        return featuresByRegion[0];
      }

      if (featuresByCity.length === 1) {
        return featuresByCity[0];
      }

      // filter if street passed
      if (geocoding.query.parsed_text.street) {
        const featuresByStreet = featuresByCity.filter((feature) => {
          if (feature.properties.street) {
            return feature.properties.street.toLowerCase() === geocoding.query.parsed_text.street?.toLowerCase();
          }
        });

        if (featuresByStreet.length === 0) {
          return featuresByCity[0];
        }

        return featuresByCity[0];
      }
    }
  }

  return sortedFeatures[0];
}
